import { useEffect } from "react";
import {
    Box,
    Heading,
    Text,
    Spinner,
    VStack,
} from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCustomTheme } from "../../contexts/CustomThemeContext";

const cardsBorderRadii = "8px";

const CheckoutPendingPage = () => {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const { theme } = useCustomTheme();

    const isDark = theme.name === "dark";

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/orders/track/${orderId}`,
                );

                const status = String(res.data?.data?.status || "").toLowerCase();

                if (status === "paid") {
                    clearInterval(interval);
                    navigate(`/checkout-success/${orderId}`);
                }

                if (status === "cancelled") {
                    clearInterval(interval);
                    navigate(`/checkout-failed/${orderId}`);
                }
            } catch {
                // keep polling quietly
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [orderId, navigate]);

    return (
        <Box minH="100%" p={{ base: 3, md: 6 }} bg={theme.background}>
            <Box
                w="full"
                mx="auto"
                p={{ base: 6, md: 8 }}
                bg={theme.surface}
                border={`1px solid ${theme.border}`}
                borderRadius={cardsBorderRadii}
                boxShadow={theme.shadowMd}
                backdropFilter={isDark ? "blur(8px)" : undefined}
            >
                <VStack spacing={4} textAlign="center">
                    <Spinner size="xl" color={theme.primary} thickness="4px" />
                    <Heading color={theme.text} size="lg">
                        Waiting for payment approval
                    </Heading>
                    <Text color={theme.textMuted}>
                        Approve the payment on your phone or complete the selected payment
                        step. This page updates automatically.
                    </Text>
                    {orderId ? (
                        <Text fontSize="sm" color={theme.textSubtle}>
                            Order ID: {orderId}
                        </Text>
                    ) : null}
                </VStack>
            </Box>
        </Box>
    );
};

export default CheckoutPendingPage;